/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/import/file-extension-required
import { callWhenIdle } from '@jira/platform__utils-call-when-idle';
import { initControlsOnce } from '@jira/platform__browser-storage-controls/src/utils/init-once/index.tsx';
import {
	type CookieCircuitBreakerConfig,
	CookieCircuitBreaker,
} from './cookie-circuit-breaker.tsx';
import { didSSRSucceed } from './did-ssr-succeed.tsx';
import { getCookieCircuitBreakerKillswitch } from './killswitch.tsx';

export function setCircuitBreakerOnIdle({
	isSetCookieEnabled,
	cookieKey,
	windowSize,
	threshold,
	keepOpenCount,
	halfOpenForCount,
	userId,
	cloudId,
}: CookieCircuitBreakerConfig & {
	isSetCookieEnabled: boolean;
	userId?: string;
	cloudId?: string;
}): void {
	if (isSetCookieEnabled) {
		callWhenIdle(async () => {
			await initControlsOnce({ userId, cloudId });
			const circuitBreaker = new CookieCircuitBreaker({
				cookieKey,
				windowSize,
				threshold,
				keepOpenCount,
				halfOpenForCount,
				version: getCookieCircuitBreakerKillswitch() ?? 0,
			});
			const didVersionMismatch = circuitBreaker.resetCookieIfVersionMismatch();
			// Do not record a pass/fail if we just reset the cookie incase it failed due
			// to the circuit breaker being OPEN
			if (!didVersionMismatch) {
				if (didSSRSucceed()) {
					circuitBreaker.recordPass();
				} else {
					circuitBreaker.recordFailure();
				}
			}
		}, 1000);
	}
}
